import { render, staticRenderFns } from "./GarbageRemovalService.vue?vue&type=template&id=5f43173a&"
import script from "./GarbageRemovalService.vue?vue&type=script&lang=js&"
export * from "./GarbageRemovalService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports